import { render, staticRenderFns } from "./Shaoguan.vue?vue&type=template&id=22576bd2&scoped=true&"
import script from "./Shaoguan.vue?vue&type=script&lang=js&"
export * from "./Shaoguan.vue?vue&type=script&lang=js&"
import style0 from "./Shaoguan.vue?vue&type=style&index=0&id=22576bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22576bd2",
  null
  
)

export default component.exports